import { EventEmitter, Output, Component, Input } from '@angular/core';
import { Store } from '@ngxs/store';
import { SearchAuctionItems, SellSearchState, SellSort, SearchService } from 'remarketing-angular-library';
import {SellSortService} from '../../services/sell-sort.service';
import { DropdownSelectComponent, TrapFocusComponent } from 'remarketing-ui-components-lib';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'lib-search-results-sort-select',
    templateUrl: './search-results-sort-select.component.html',
    styleUrls: ['./search-results-sort-select.component.scss'],
    imports: [TrapFocusComponent, DropdownSelectComponent, AsyncPipe]
})
export class SearchResultsSortSelectComponent{
  @Input() public selection: string;
  @Input() label: string;
  @Input() stacked = false;
  @Output() public sortSelectionChangedEvent = new EventEmitter<string>();
  enableFocusTrap = false;
  bookValue: string;

  constructor(
    private readonly store: Store,
    readonly sellSortService: SellSortService,
    private readonly searchService: SearchService
  ) {
  }

  public updateSort(option) {
    if (option && option.dataset && option.dataset.value) {
      const sortOption = option.dataset.value ? option.dataset.value.split('__') : ['', ''];

      const currentRequest = this.store.selectSnapshot(SellSearchState.searchRequest);

      const payload = {
        ...currentRequest,
        page: 0,
        sortBy: sortOption[0],
        sortOrder: sortOption[1]
      };

      // Include Book Value Provider if sorting by average book value
      if (option.dataset.value === SellSort.AVERAGE_BOOK_VALUE__DESC || option.dataset.value === SellSort.AVERAGE_BOOK_VALUE__ASC) {
        let preferences = this.searchService.searchPreferences.getValue();
        if (!preferences) {
          this.searchService.getLoadPreferences();
          preferences = this.searchService.searchPreferences.getValue();
        }
        payload.bookValueProvider = preferences.bookSpread.bookValueSpreadType;
      } else {
        payload.bookValueProvider = null;
      }
      this.store.dispatch(new SearchAuctionItems(payload));
    }
  }

  onOpenChange(e) {
    this.enableFocusTrap = e;
  }
}
